var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTool = function SvgIconTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M11.886 15.75a2.501 2.501 0 0 1-4.772 0H2.75a.75.75 0 0 1 0-1.5h4.364a2.501 2.501 0 0 1 4.772 0h5.364a.75.75 0 0 1 0 1.5zM18 10a2.5 2.5 0 0 0-4.885-.75H2.75a.75.75 0 0 0 0 1.5h10.365A2.501 2.501 0 0 0 18 10M2 5a2.5 2.5 0 0 1 4.886-.75H17.25a.75.75 0 0 1 0 1.5H6.886A2.501 2.501 0 0 1 2 5"
  })));
};
export default SvgIconTool;